export default function createFiltersPanelTrackingService(
    track: (category: string, action: string, eventName: string) => void,
) {
    function trackWithDefaultCategory(action: string, eventName: string) {
        track("lead gen filter actions", action, eventName);
    }

    return {
        trackSaveAsNewSearchClicked(numberOfFilters: number, numberOfResults: number) {
            trackWithDefaultCategory("save as new search", `save search/${numberOfFilters}/${numberOfResults}`);
        },
        trackUpdateSearchClicked(name: string, numberOfFilters: number) {
            trackWithDefaultCategory("update exisintg search", `save search/${name}/${numberOfFilters}`);
        },
    };
}
